module.exports = __webpack_public_path__ + "img/img (27).c196915a.png";